"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiListSearch = void 0;
const core_api_1 = require("@ikegps/core-api");
const image_button_1 = require("../../components/button/image.button");
const icon_1 = require("../../components/icon");
const icons_1 = require("../../components/icon/icons");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const multi_list_search_style_1 = require("./multi.list.search.style");
(0, theme_1.addStyles)(multi_list_search_style_1.Style);
class MultiListSearch extends mithril_component_1.IMithrilComponent {
    get nodes() {
        //the filterbar is an IKE Analyze only feature
        if (!services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
            services_1.Services.MultiListSearch.filterState.clear();
            services_1.Services.MultiListSearch.inputfilterState.clear();
            return null;
        }
        const cancelButton = image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            className: multi_list_search_style_1.CSS.clear,
            onclick: () => services_1.Services.MultiListSearch.reset()
        });
        const icon = services_1.Services.MultiListSearch.filtering ?
            spinner_1.Spinner.view(multi_list_search_style_1.CSS.icon) :
            icon_1.Icon.view(icons_1.MaterialIcon.SEARCH, { className: multi_list_search_style_1.CSS.icon });
        return (0, mithril_1.m)('div', { className: multi_list_search_style_1.CSS.container }, [
            icon,
            (0, mithril_1.m)('input', {
                className: multi_list_search_style_1.CSS.input,
                type: 'text',
                placeholder: (0, index_1.Translate)(index_1.T.FILTER),
                value: services_1.Services.MultiListSearch.inputfilterState.filter,
                oninput: e => this.onChange(e)
            }),
            services_1.Services.MultiListSearch.inputfilterState.hasFilter() ? cancelButton : null
        ]);
    }
    onChange(e) {
        services_1.Services.MultiListSearch.inputfilterState.setFilter(e.target.value);
    }
}
exports.MultiListSearch = MultiListSearch;
//# sourceMappingURL=multi.list.search.js.map